import { render, staticRenderFns } from "./PostButton.vue?vue&type=template&id=e36e5614&"
import script from "./PostButton.vue?vue&type=script&lang=ts&"
export * from "./PostButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports